/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SerieSerieidLangsQueryResponse,
  GetApiV1SerieSerieidLangsPathParams,
  GetApiV1SerieSerieidLangsQueryParams,
  GetApiV1SerieSerieidLangs401,
  GetApiV1SerieSerieidLangs404,
  GetApiV1SerieSerieidLangs500,
} from "../../types/serieIdiomasController/GetApiV1SerieSerieidLangs.ts";

function getGetApiV1SerieSerieidLangsUrl(
  serieId: GetApiV1SerieSerieidLangsPathParams["serieId"],
) {
  const res = { method: "GET", url: `/api/v1/serie/${serieId}/langs` as const };
  return res;
}

/**
 * @description Retorna a lista paginada de traduções (idiomas) de uma série. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas da série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs}
 */
export async function getApiV1SerieSerieidLangs(
  serieId: GetApiV1SerieSerieidLangsPathParams["serieId"],
  params?: GetApiV1SerieSerieidLangsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SerieSerieidLangsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerieSerieidLangs401
      | GetApiV1SerieSerieidLangs404
      | GetApiV1SerieSerieidLangs500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SerieSerieidLangsUrl(serieId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
